import { app } from '../../../../../../../app';
import { Controller } from './upload-result.controller';

app.component('companyUserDirectoriesDirectoryGroupsDirectoryImportUsersUploadResult', {
    bindings: {importResult: '<'},
    controller: Controller,
    templateUrl: require('./upload-result.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/import-users/upload-result/upload-result.component.js